module.exports = __webpack_public_path__ + "static/media/korea.a79f4114.png";